module.exports = __webpack_public_path__ + "static/media/user-2.c5d8b333.jpg";